<template>
	<div class="MAM_brandList">
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<div style="margin-bottom: 20px;">
				<el-button size="small" type="primary" icon="el-icon-plus" @click="handleAddBrand">添加分红档位</el-button>
			</div>
			<el-table :data="brandTable" size="mini" border style="width: 100%" max-height="500px" v-loading="loading">
                <el-table-column header-align="center" align="center" prop="id" label="档位ID" min-width="80"></el-table-column>
					
				<el-table-column header-align="center" align="center" prop="level_name" label="档位名称" min-width="120"></el-table-column>
                <el-table-column header-align="center" align="center" label="下级代理达标位数" prop="is_qualified_num" min-width="120">
                </el-table-column>
				<el-table-column header-align="center" align="center" label="月交易量≥（万元）" prop="month_transaction_money" min-width="120">
				</el-table-column>
				<el-table-column header-align="center" align="center" label="分红奖励（%）" prop="reward_ratio" min-width="120">
				</el-table-column>
                <el-table-column header-align="center" align="center" label="关联政策类型" prop="reward_ratio" min-width="120">
                    
                    <template slot-scope="scope">
                    	<span>2.0政策</span>
                    </template>
                </el-table-column>
                <el-table-column header-align="center" align="center" label="活动时间" prop="" min-width="200">
                    <template slot-scope="scope">
                    	<span>{{scope.row.start_time}} - {{scope.row.end_time}}</span>
                    </template>
                </el-table-column>
				<el-table-column header-align="center" align="center" prop="create_time" label="创建时间" min-width="150"></el-table-column>
                <el-table-column header-align="center" align="center" prop="update_time" label="更新时间" min-width="150"></el-table-column>
                <el-table-column header-align="center" align="center" fixed="right" label="操作" min-width="170">
                	
                    <template slot-scope="scope">
                    	<el-button v-if="scope.row.status == 1"  @click="editDataClick(scope.row)" type="text" size="small">编辑</el-button>
                    	<el-button v-if="scope.row.status == 1" @click='delClick(scope.row)' type="text" size="small">停用</el-button>
                        <span v-if="scope.row.status == 2" style="color: red;">已停用</span>
                    </template>
                </el-table-column>
			</el-table>
		</el-card>
		<!-- 添加 -->
		<el-dialog :title="isEdit?'编辑':'添加'" width="800px" :visible="addBrand" :close-on-click-modal="false" @close="handleClose">
			<el-form style = "width: 90%;" class="demo-form-inline" label-width="100px" :model="form" :rules="rules" ref="ruleForm">
				<el-form-item label="档位名称" prop="level_name">
					<el-input size clearable v-model="form.level_name" placeholder="请输入档位名称" style="width:90%;"></el-input>
				</el-form-item>
                <el-form-item label="下级达标位数" prop="is_qualified_num">
                	<el-input size clearable v-model="form.is_qualified_num" placeholder="请输入下级达标位数" style="width:90%;"></el-input>
                    <span style="margin-left: 10px;">位</span>
                </el-form-item>
                <el-form-item label="月交易量≥" prop="month_transaction_money">
                	<el-input size clearable v-model="form.month_transaction_money" placeholder="请输入月交易量" style="width:90%;"></el-input>
                    <span style="margin-left: 10px;">万元</span>
                </el-form-item>
                <el-form-item label="分红奖励(%)" prop="reward_ratio">
                	<el-input size clearable v-model="form.reward_ratio" placeholder="请输入分红奖励" style="width:90%;"></el-input>
                    <span style="margin-left: 10px;">%</span>
                </el-form-item>
                <el-form-item  label="活动时间" prop="rangeDate">
                    <el-date-picker
                        style="width:90%;"
                        size="medium"
                        v-model="form.rangeDate"
                        format="yyyy-MM"
                        value-format="yyyy-MM"
                        :picker-options="pickerOptions"
                        type="monthrange"
                        @change="pickerChange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="截止日期">
                    ></el-date-picker>
                </el-form-item>
				<el-form-item label="关联政策类型" prop="brand_type">
					<el-select size clearable v-model="form.brand_type" placeholder="请选择关联政策类型"  style="width:90%;">
                        <!-- <el-option label="1.0政策" :value="1"></el-option> -->
						<el-option label="2.0政策" :value="2"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose()">取 消</el-button>
				<el-button type="primary" @click="addSubmit('ruleForm')">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: "bigDividendRule",
		inject: ['reload'],
		data() {
			return {
				brandTable: [],
				isEdit:false,
                pickerOptions: { //禁止选之前的时间
                    disabledDate(time) {
                        return time.getTime() < (Date.now() - 86400000*((new Date()).getDate()));
                    }
                },
				loading: true,
				//新增
				addBrand: false,
				form: {
					brand_type: 2,
                    level_name:'',
                    is_qualified_num:'',
                    month_transaction_money:'',
                    reward_ratio:'',
                    end_time:'',
                    start_time:'',
                    id:'',
                    rangeDate:[],
				},
				rules: {
					level_name: [{
						required: true,
						message: '请输入档位名称',
						trigger: 'blur'
					}],
                    is_qualified_num: [{
                    	required: true,
                    	message: '请输入下级达标位数',
                    	trigger: 'blur'
                    }],
                    month_transaction_money: [{
                    	required: true,
                    	message: '请输入月交易量',
                    	trigger: 'blur'
                    }],
                    reward_ratio: [{
                    	required: true,
                    	message: '请输入分红奖励',
                    	trigger: 'blur'
                    }],
                    rangeDate:[{
                    	required: true,
                    	message: '请选择活动时间',
                    	trigger: 'blur'
                    }],
                    start_time: [{
                    	required: true,
                    	message: '请选择活动开始时间',
                    	trigger: 'blur'
                    }],
                    end_time: [{
                    	required: true,
                    	message: '请选择活动截止时间',
                    	trigger: 'blur'
                    }],
					brand_type: [{
						required: true,
						message: '请选择关联政策类型',
						trigger: 'change'
					}]
				}
			}
		},
		mounted() {
			this.getData({
				page: 1,
				limit: 100,
			})
		},
		methods: {
            
            pickerChange(DateArr) { //时间选择器
            console.log(DateArr);
                this.form.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
                this.form.end_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
            },
            
            editDataClick(item){
                this.addBrand = true;
                this.isEdit = true
                this.form.level_name = item.level_name
                this.form.is_qualified_num = item.is_qualified_num
                this.form.month_transaction_money = item.month_transaction_money
                this.form.reward_ratio = item.reward_ratio
                this.form.start_time = item.start_time.split('-')[0] + '-' + item.start_time.split('-')[1]
                this.form.end_time = item.end_time.split('-')[0] + '-' + item.end_time.split('-')[1]
                this.form.rangeDate = [this.form.start_time,this.form.end_time]
                this.form.id = item.id
                
            },
            
            delClick(item) {
                this.$confirm('是否确定停用？', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(()=>{
                	   this.$api.post("user_dividends/upDividendsLevelStatus", {id:item.id,status:2}, res => {
                		   if (res.code == 0) {
                			   this.$message.success(res.msg);
                			   this.getData({
                			   	page: 1,
                			   	limit: 100,
                			   })
                		   }else {
                			   this.$message.error(res.msg);
                		   }
                	   })
                	
                	
                }).catch(err=>{});
            },
            
			//档位配置  提交(编辑)
			addSubmit(formName) {
				console.log(this.form)
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api.post("user_dividends/saveUserDividendsLevel", this.form, res => {
							if (res.code == 0) {
								this.addBrand = false;
								this.$message({
									type: 'success',
									message: res.msg,
									duration: 2000,
								})
								this.$refs[formName].resetFields();
								this.form = {
									brand_type: 2,
									level_name:'',
									is_qualified_num:'',
									month_transaction_money:'',
									reward_ratio:'',
									end_time:'',
                                    start_time:'',
                                    rangeDate:[]
								};
								this.getData({
									page: 1,
									limit: 100,
								})
							}else{
								this.$message({
									type: 'error',
									message: res.msg,
									duration: 2000,
								})
							}
						})
					}
				});
			},
			//打开  关闭   新增配置
			handleAddBrand() {
                this.isEdit = false
				this.addBrand = true;
			},
			handleClose() {
				this.addBrand = false;
				this.$refs.ruleForm.resetFields();
				this.form = {
					brand_type: 2,
					level_name:'',
					is_qualified_num:'',
					month_transaction_money:'',
					reward_ratio:'',
					end_time:'',
                    start_time:'',
                    rangeDate:[]
				};
			},

			getData(params) {
				this.$api.post("user_dividends/userDividendsLevelPage", params, res => {
					let data = res.data;
					this.brandTable = data.list;
					//渲染结束后取消加载
					this.loading = false;
				})
			},
		}
	};
</script>

<style lang="scss" scoped>
	.tableDiv {
		overflow-x: scroll;
	}
	.el-form-item {
		margin-bottom: 20px !important;
	}
</style>